import { Luscinia, luscinia } from "./luscinia";

const addColumnBtn = document.getElementById('addColumn') as HTMLButtonElement;
const saveBtn = document.getElementById('save');
const exportExcelBtn = document.getElementById('exportExcel');
const recordSelect = document.querySelector('select[name="record"]');
const excelReportNameInputEl = document.querySelector('input[name="excelReportName"]') as HTMLInputElement;

let availableColumns = [];
let excelReport;
let record = getRecordFromQueryParams();
let isCurrentReportSaved = false;

(window as any).initExcelTool = function initExcelTool() {
    //Event listeners
    addColumnBtn.addEventListener('click', addColumn);
    saveBtn.addEventListener('click', saveReportRecord);
    exportExcelBtn.addEventListener('click', excelExport);
    $('select[name="record"]').on('change', function () {
        updateAvailableColumns(getSelect2Data(this));
    });

    if (!record.isNew) {
        renderRecord(record.id).then(function () {
            initSelect2();
        });
    } else {
        initSelect2();
        setAvailableColumns(getSelect2Data($('select[name="record"]')));
    }
}

function renderRecord(excelReportId) {
    return $.get(`/data/excelreports/exceltool/${excelReportId}`, function (data) {
        excelReport = JSON.parse(data.json);
        excelReportNameInputEl.value = excelReport.reportName;
        $('select[name="record"]').val(excelReport.recordName).trigger('change.select2');
        updateAvailableColumns(excelReport.recordName).then(function () {
            renderColumns();
        });
    });
}

function renderColumns() {
    if (excelReport) {
        excelReport.selectedColumns.forEach(function (column) {
            addColumn(column);
        });
    }
}

function getRecordFromQueryParams() {
    const currentUrl = new URL(window.location.href);
    const params = new URLSearchParams(currentUrl.search);

    let record = {
        isNew: params.get('action') == 'edit' ? false : true,
        id: params.get('id'),
    };
    return record;
}

function updateAvailableColumns(recordName) {
    clearColumns();
    return setAvailableColumns(recordName);
}

function setAvailableColumns(recordName) {
    return $.get(`/data/excelreports/exceltool/recordcolumns/${recordName}`, function (data) {
        availableColumns = [];
        data.forEach(function (column) {
            availableColumns.push(column);
        });
    });
}

function initSelect2() {
    const selectElements = document.querySelectorAll('select');
    selectElements.forEach(function (el) {
        $(el).select2({ theme: 'bootstrap-5' });
    });
}

function constructSelect2El(selectedValue) {
    let div = document.createElement('div');
    div.classList.add('select2-group', 'd-flex', 'gap-2', 'align-items-center');
    div.innerHTML = `
        <select name="column">
            ${constructOptions(selectedValue)}
        </select>
        <div class="btn btn-outline-danger"><i class="fa fa-trash"></i></div>
    `;
    return div;
}

function constructOptions(selectedValue) {
    let output = '';
    availableColumns.forEach(function (column) {
        output += `<option ${selectedValue == column ? 'selected' : ''} value="${column}">${column}</option>`;
    });
    return output;
}

function addColumn(selectedValue) {
    const excelLayoutEl = document.querySelector('.excel-layout') as HTMLElement;
    let select2Group = excelLayoutEl.appendChild(constructSelect2El(selectedValue));
    let selectElement = $(select2Group).find('select');
    let removeBtn = $(select2Group).find('.remove-btn');
    $(selectElement).select2({ theme: 'bootstrap-5' });
    addEventListeners(removeBtn);
}

function removeSelect2(removeBtn) {
    removeBtn.closest('.select2-group').remove();
}

function addEventListeners(removeBtn) {
    removeBtn[0].addEventListener('click', function () {
        removeSelect2(removeBtn);
    });
}

function saveReportRecord() {
    sendSaveRequest().then(function () {
        if (isCurrentReportSaved) {
            returnToGrid();
        }
    });
}

function hasDuplicates(arr) {
    return new Set(arr).size !== arr.length;
}

function sendSaveRequest() {
    const excelReportName = (document.querySelector('input[name="excelReportName"]') as HTMLInputElement).value;
    let excelReportJson = getExcelReportJson();

    if (excelReportName.length == 0) {
        luscinia.showNotification('Report is not saved', 'Provide a name', 'danger');
        return;
    }
    if (JSON.parse(excelReportJson).selectedColumns.length == 0) {
        luscinia.showNotification('Report is not saved', 'There is no column selected', 'danger');
        return;
    }
    if (hasDuplicates(JSON.parse(excelReportJson).selectedColumns)) {
        luscinia.showNotification('Report is not saved', 'Cannot select same column twice', 'danger');
        return;
    }

    if (record.isNew) {
        let excelreport = {
            Name: excelReportName,
            Json: excelReportJson,
        };
        return $.ajax({
            type: 'POST',
            url: '/data/excelreports/exceltool/record',
            data: JSON.stringify(excelreport),
            contentType: 'application/json',
            dataType: 'json',
        }).done(function (data) {
            handleSaveResponse(data);
        });
    } else {
        let excelreport = {
            Id: record.id,
            Name: excelReportName,
            Json: excelReportJson,
        };
        return $.ajax({
            type: 'PUT',
            url: `/data/excelreports/exceltool/${record.id}`,
            data: JSON.stringify(excelreport),
            contentType: 'application/json',
            dataType: 'json',
        }).done(function (data) {
            handleSaveResponse(data);
        });
    }
}

function excelExport() {
    sendSaveRequest().then(function () {
        if (record.id && isCurrentReportSaved) {
            window.open(`/data/excelreports/exceltool/export/${record.id}`);
            returnToGrid();
        }
    });
}

function returnToGrid() {
    window.location.href = '/management-excel-report-wizard';
}

function handleSaveResponse(data: any) {
    if (!data.saved) {
        if (data.error === 'ReportName not unique') {
            luscinia.showNotification('Report is not saved', 'Report preset with same name already exists', 'danger');
        } else {
            luscinia.showNotification('Report is not saved', 'Unknown error', 'danger');
        }
        isCurrentReportSaved = false;
    } else {
        if (record.isNew) {
            record.id = data.savedReportId;
        }
        isCurrentReportSaved = true;
    }
}

function getExcelReportJson(): string {
    const recordName = getSelect2Data(document.querySelector('select[name="record"]'));
    const reportName = (document.querySelector('input[name="excelReportName"]') as HTMLInputElement).value;
    const columns = getColumns();

    let layoutJson = {
        recordName: recordName,
        reportName: reportName,
        selectedColumns: columns,
    };

    return JSON.stringify(layoutJson);
}

function getColumns(): Array<string> {
    const columnSelect2Els = document.querySelectorAll('.excel-layout select');

    let columns = [];
    columnSelect2Els.forEach(function (el) {
        columns.push(getSelect2Data(el));
    });

    return columns;
}

function clearColumns() {
    const columnContainer = document.querySelector('.excel-layout');
    columnContainer.innerHTML = '';
}

function getSelect2Data(select2Element) {
    return $(select2Element).select2('data')[0].id;
}
